<template>
<div class="modal is-large is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Configure backup options</span>
                <span class="default-settings-subtitle">Fine tune the backup options of this schedule.</span>
            </div>

            <!-- <div v-if="loadingBackupFlags" class="columns m-top-15">
                <div class="column is-full has-text-centered">
                    <img src="/loader-dark.svg">
                </div>
            </div> -->

            <div class="columns is-multiline" style="margin-bottom: 35px;">
                <div class="column is-full m-top-20">
                    <div class="field">
                        <input type="text" v-model="name" @keyup.enter="updateBackupFlags" :class="{ 'is-danger': hasError('name') }" class="input custom-input-size is-medium" placeholder="Schedule name" autocomplete="off" :disabled="updatingBackupFlags" />
                        <span v-if="!hasError('name')" class="help">An intuitive name to recognize the file backup schedule later, e.g. <b>my website backup</b></span>
                        <span v-if="hasError('name')" class="help is-danger">{{ getError('name') }}</span>
                    </div>
                </div>

                <div class="column is-full">
                    <div style="color: #353b48; margin-bottom: 8px; margin-top: 10px;">File paths to backup</div>                    
                    <div class="field">
                        <textarea v-model="includedPaths" class="textarea custom-input-size" placeholder="/var/www/html/my-website" style="padding: 10px 15px !important;" :disabled="updatingBackupFlags"></textarea>
                        <span v-if="!hasError('included_paths')" class="help">Absolute paths of directories/files that should be included in the backup. One path per line.</span>
                        <span v-if="hasError('included_paths')" class="help is-danger">{{ getError('included_paths') }}</span>
                    </div>
                </div>
                
                <div class="column is-full">
                    <div style="color: #353b48; margin-bottom: 8px; margin-top: 10px;">File paths to exclude</div>
                    <div class="field">
                        <textarea v-model="excludedPaths" class="textarea custom-input-size" style="padding: 10px 15px !important;" :disabled="updatingBackupFlags"></textarea>
                        <span v-if="!hasError('excluded_paths')" class="help">Absolute paths of directories/files that should be excluded from the backup. One path per line.</span>
                        <span v-if="hasError('excluded_paths')" class="help is-danger">{{ getError('excluded_paths') }}</span>

                        <!-- <input type="text" :class="{ 'is-danger': hasError('host') }" class="input custom-input-size is-medium" placeholder="/" autocomplete="off" :disabled="storingServer" /> -->
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" style="margin-top: 10px;">
                <div class="column is-3">
                    <div @click="updateBackupFlags" :disabled="updatingBackupFlags" :class="{ 'is-loading': updatingBackupFlags }" class="button custom-button-size is-fullwidth is-info">Save</div>
                </div>
                <div class="column is-3">
                    <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="updatingBackupFlags">Cancel</div>
                </div>
            </div>
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';
import FormErrorsMixin from '@/mixins/FormErrors';

export default {
    props: ['file'],

    mixins: [FormErrorsMixin],

    data() {
        return {
            name: '',
            includedPaths: '',
            excludedPaths: '',
            allowedInputs: ['name', 'included_paths', 'excluded_paths'],
            updatingBackupFlags: false,
        }
    },

    mounted() {
        this.name = this.file.name;
        this.includedPaths = this.file.flags.included_paths.join('\n'),
        this.excludedPaths = this.file.flags.excluded_paths.join('\n'),

        this.listenEvents();
    },

    methods: {
        close() {
            if (!this.creatingFile) {
                Event.$emit('configureBackupOptionsModalClosed');
            }
        },

        listenEvents() {
            //
        },

        getBackupFlags() {
            // this.loadingBackupFlags = true;

            // Api().get('files/' + this.file.id + '/flags/backup')
            //     .then((response) => {
            //         this.targetType = response.data.target.type;
            //         this.targetTables = response.data.target.tables;

            //         if (this.database.type == 'mysql') {
            //             this.mysql.singleTransaction = this.mysqlOptionIsEnabled('--single-transaction', response.data.options);
            //             this.mysql.skipLockTables = this.mysqlOptionIsEnabled('--skip-lock-tables', response.data.options);
            //         }
            //     })
            //     .finally(() => {
            //         this.loadingBackupFlags = false;
            //     });
        },

        updateBackupFlags() {
            if (this.updatingBackupFlags) {
                return;
            }

            this.resetErrors();
            this.updatingBackupFlags = true;

            Api().put('files/' + this.file.id, this.fileData)
                .then(() => {
                    Event.$emit('backupFlagsChanged', () => {
                        swal('Success!', 'Backup options changed successfully.', 'success');
                    });
                })
                .catch((error) => {
                     if (error.response.status == 409) {
                        Event.$emit('backupFlagsChanged', () => {
                            Swal.fire({
                                title: 'Oops',
                                text: 'The last backup is still pending or in progress. Wait until it\'s done before changing the backup options.',
                                type: 'error',
                            });
                        });
                    } else {
                        this.storeErrors(error.response.data.errors);
                    }
                })
                .finally(() => {
                    this.updatingBackupFlags = false;
                });
        },

        mysqlOptionIsEnabled(option, enabledOptions) {
            return enabledOptions.indexOf(option) > -1;
        },
    },

    computed: {
        fileData() {
            return {
                name: this.name,
                included_paths: this.includedPaths,
                excluded_paths: this.excludedPaths,
            }
        },
    },
}
</script>
